import auth from '../authentication';
import Vue from '../main';

export default {
    getDonation(context, data, callback) {
        Vue.http.post(Vue.apiUrl + '/donation/get-all', data)
            .then(response => {
                context.error = false;
                context.donation = response.data.data;
                context.total = response.data.total;
                callback(context);
            })
            .catch(response => {
                context.error = true;
                context.message = response.data.message;
                context.total = 0;
                callback(context);
            })
    },
};